<template lang="html">
  <div id="participation-counter-placeholder" />
</template>

<script>
  /*eslint-disable */

  import { mapGetters } from 'vuex';

  // NOTE: importing d3 from node_modules is currently breaking webpack
  // index.html is importing it through CDN

  export default {
    data() {
      return {};
    },
    computed: {
      ...mapGetters(['getClassSummaryLD']),
    },
    mounted() {
      const d3 = window.d3version4;
      const that = this;

      let participations = 0;
      that.getClassSummaryLD.student_participations.forEach((s) => {
        s.times_spoken > 0 ? participations++ : null;
      });

      let endVal = Math.floor(
        (participations /
          that.getClassSummaryLD.student_participations.length) *
          100
      );

      endVal = isNaN(endVal) ? 0 : endVal;

      const svg = d3
        .select('#participation-counter-placeholder')
        .append('svg')
        .attr('width', 150)
        .attr('height', 80);

      const text = svg
        .append('text')
        .attr('x', '50%')
        .attr('y', '80%')
        .attr('font-size', '49px')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'middle')
        .text('0')
        .style('fill', '#eb2d7C')
        .transition()
        .tween('text', function () {
          const selection = d3.select(this);
          const start = d3.select(this).text();
          const end = endVal;
          const interpolator = d3.interpolateNumber(start, end);

          return function (t) {
            selection.text(Math.floor(interpolator(t)) + '%');
          };
        })
        .duration(900);
    },
  };

  /*eslint-enable */
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  #student-name
    font-weight: bold
    font-size: 18px

  #total-time
    font-weight: bold
    font-size: 30px

  .text-minutes
    font-size: 12px
    opacity: 0

  .axis path,
  .axis line
    fill: none
    stroke: #000
    shape-rendering: crispEdges

  .bar
    fill: orange

  .solidArc
    -moz-transition: all 0.3s
    -o-transition: all 0.3s
    -webkit-transition: all 0.3s
    transition: all 0.3s

  .x.axis path
    display: none

  .d3-tip
    line-height: 1
    font-weight: bold
    padding: 12px
    background: rgba(0, 0, 0, 0.8)
    color: #fff
    border-radius: 2px
    z-index: 999
</style>



// WEBPACK FOOTER //
// participationCounter.vue?81d7c29c